import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoginAlert from "../LoginAlert/LoginAlert";
import NewFilter from "../FilterOrders/NewFilter";
import { useOrders } from "../../pages/DefaultPage/connect/Orders";
import SearchInput from "../SearchInput/SearchInput";
import useShowModal from "../store/useShowModal";
import { useAuth } from "../../pages/login/connect/Login";
import { Modal, Dropdown } from "antd";
import { useLocations } from "../../States/Location/Location";
import useLocationStore from "../store/locationStore";
import { useSearchStore } from "../store/searchStore";
import ChooseLocModal from "../ChooseLocModal/ChooseLocModal";

function DesktopHeader() {
  const { provinceCode, cityCode, setProvinceCode, setCityCode } = useLocationStore();


  const [isShowLogoutModal, setIsShowLogOutModal] = useState(false);
  const [selectedProvinceID, setSelectedProvinceID] = useState(provinceCode);
  const [selectedCityID, setSelectedCityID] = useState(cityCode);
  const [isExitVisible, setIsExitVisible] = useState(false);
  const {
    getExchange,
    getMasterOrders,
    getAdsPicMasterByMasterPriorityId,
    getAdsMasterSearch,
    getDetailMasterByQueryByAllStrings,
  } = useOrders((state) => state.actions);
  const { setSearchValue, setIsSearch } = useSearchStore();
  const { getUserInfoByToken } = useAuth((state) => state.actions);
  const { getAllProvinses, getAllCities, getAllAreas, getLocationName } = useLocations((state) => state.actions);

  const provinses = useLocations((state) => state.provinses);
  const cities = useLocations((state) => state.cities);
  const areas = useLocations((state) => state.areas);
  const locationName = useLocations((state) => state.locationName);
  const loadingAreas = useLocations((state) => state.loadingAreas);
  const subscriptionMains = useAuth((state) => state.subscriptionMains);
  const allMasterOrders = useOrders((state) => state.allMasterOrders);
  const [showRemainingDays, setShowRemainingDays] = useState(false);
  const [isChooseProvinceModalOpen, setIsChooseProvinceModalOpen] = useState(false);
  const [searchValueFromAllAds, setSearchValueFromAllAds] = useState("")
  const [selectedProvinceName, setSelectedProvinceName] = useState("استان");
  const [selectedCityName, setSelectedCityName] = useState("شهر");
  const [selectedAreaName, setSelectedAreaName] = useState("محله");
  const location = useLocation();
  const [activeMenuItem, setActiveMenuItem] = useState(3);
  const [isChooseLocModalOpen, setIsChooseLocModalOpen] = useState(false);
  // const [showLoginAlert, setShowLoginAlert] = useState(false);
  const showLoginAlert = useShowModal((state) => state.showLoginAlert);
  const setShowLoginAlert = useShowModal((state) => state.setShowLoginAlert);
  const navigate = useNavigate();
  const newFilterSearchRef = useRef(null); // 🟩 create the ref
  const desMenuItems = [
    { id: 5, title: "خانه", src: "/desktop/icons/home.svg", link: "/" },
    // {
    //   id: 1,
    //   title: "دسته بندی ها",
    //   src: "/desktop/icons/category.svg",
    //   link: "/CategoryView",
    // },
    {
      id: 2,
      title: "ثبت آگهی",
      src: "/icons/pelake-man-header-add.svg",
      link: "/CreateFile",
    },
    // { id: 3, title: "همه آگهی ها", src: "/desktop/icons/all.svg", link: "/" },
    {
      id: 4,
      title: "پروفایل",
      src: "/desktop/icons/profile.svg",
      link: "/Profile",
    },
  ];

  const checkAuthForAddOrder = (id) => {
    setActiveMenuItem(id);
    console.log(id);
    // setActiveMenuItem(id)
    if (localStorage.getItem("pelakAuthData")) {
      if (id == 4) {
        navigate("/Profile");
      } else if (id == 2) {
        navigate("/RegisterAD");
      }
    } else {
      setShowLoginAlert(true);
    }
  };
  const searchHandler = (value) => {
    setSearchValue(value); // Update the search value
    setIsSearch(true);     // Trigger the search
  };
  // const searchHandler = () => {

  //   setIsSearch(true);
  //   if (searchValue.length > 2) {
  //     // getAdsMasterSearch(searchValue, 0);
  //   }
  //   if (searchValue == "") {
  //     // getMastersHandler();
  //     // setIsSearch(false);
  //   }
  // };
  const getMastersHandler = async () => {
    if (allMasterOrders && allMasterOrders.length == 0) {
      await getMasterOrders();
    }
    // allMasterOrders.map(item => {
    //     console.log("jknmkj");
    //     getAdsPicMasterByMasterPriorityId(item.id , 1)
    // })
  };
  const closeModalsWithClickOnDocument = (e) => {
    if (e.target.className.includes("style-for-close-on-outside")) {
      document.removeEventListener("click", setIsShowLogOutModal(false));
    }
  };
  const [openSuccess, setOpenSuccess] = useState(false);
  const handleYes = () => {
    localStorage.clear();
    setIsShowLogOutModal(false);
    setOpenSuccess(true);
    setIsExitVisible(false)
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };
  console.log(locationName?.locName,);

  useEffect(() => {
    setTrue()
    getUserInfoByToken(0)
    getAllProvinses()
    // getLocationName((provinceCode || cityCode ?( provinceCode ? provinceCode : cityCode) : 2))
  }, [])
  const setTrue = () => {
    if (localStorage.getItem("pelakToken")) {
      setIsExitVisible(true)
    }

  }
  const items = provinses.map((province) => ({
    key: province.id.toString(), // Required unique key
    label: province.locName, // The text to display
  }));

  const menuProps = {
    items,
    onClick: (e) => {
      // console.log("Selected Province ID:", e.key);
      // setSelectedProvinceID(e.key)
      // getAllCities(e.key)
      const selectedProvince = provinses.find(prov => prov.id.toString() === e.key);
      if (selectedProvince) {
        setSelectedProvinceID(e.key);
        setSelectedProvinceName(selectedProvince.locName); // Update displayed text
        getAllCities(e.key);
        setProvinceCode(e.key);
      }
    },
  };

  const cityItems = cities.map((city) => ({
    key: city.id.toString(), // Required unique key
    label: city.locName, // The text to display
  }));
  const areaItems = areas.map((city) => ({
    key: city.id.toString(), // Required unique key
    label: city.locName, // The text to display
  }));



  const cityMenuProps = {
    items: cityItems,
    // onClick: (e) => {
    //   const selectedCity = cities.find(city => city.id.toString() === e.key);
    //   if (selectedCity) {
    //     setSelectedCityID(e.key);
    //     setSelectedCityName(selectedCity.locName); // Update displayed text
    //     getAllAreas(e.key);
    //     setCityCode(e.key);
    //     setIsChooseProvinceModalOpen(false)

    //   }
    // },
    onClick: (e) => {
      const selectedCity = cities.find(city => city.id.toString() === e.key);
      if (selectedCity && cityCode !== e.key) { // Check if cityCode is different
        setSelectedCityID(e.key);
        setSelectedCityName(selectedCity.locName); // Update displayed text
        getAllAreas(e.key);
        setCityCode(e.key); // Update Zustand store only if necessary
        setIsChooseProvinceModalOpen(false);
      }
    },
  };
  const areaMenuProps = {
    items: areaItems,
    onClick: (e) => {
      const selectedArea = areas.find(area => area.id.toString() === e.key);
      if (selectedArea) {
        setSelectedAreaName(selectedArea.locName); // Update displayed text
      }
    },
  };
  const localStorageSetter = () => {
    selectedProvinceID && localStorage.setItem("province-code", selectedProvinceID)
    selectedCityID && localStorage.setItem("city-code", selectedCityID)
    setIsChooseProvinceModalOpen(false)
  }
  // const CalculateRemainingDays = (endDate) => {
  //   console.log(endDate, " endDate endDate 44444444555555555");

  //   if (!endDate) return "بدون تاریخ";
  //   const endDateObj = new Date(endDate);
  //   const currentDate = new Date();
  //   const timeDifference = endDateObj - currentDate;
  //   // Convert the time difference from milliseconds to days
  //   const remainingDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  //   console.log(remainingDays, "remainingDays");
  //   return remainingDays
  // };







  const CalculateRemainingDays = (endDate) => {
    if (!endDate) return null;
    const endDateObj = new Date(endDate);
    const currentDate = new Date();
    const timeDifference = endDateObj - currentDate;
    // Convert the time difference from milliseconds to days
    return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  };

  const getSubscriptionsWithLessThanSevenDays = (subscriptions) => {
    console.log(subscriptions, " subscriptions subscriptions subscriptions ");

    const filteredSubscriptions = subscriptions.filter((subscription) => {
      const remainingDays = CalculateRemainingDays(subscription.endDate);
      console.log(remainingDays, "remainingDays ");

      return remainingDays <= 7 && remainingDays > 0; // Only include subscriptions with 7 or fewer days remaining
    });

    const messages = filteredSubscriptions.map((subscription) => {
      const remainingDays = CalculateRemainingDays(subscription.endDate);
      const neighborhoods = subscription.tblUsrSubscriptionDetails
        .map((detail) => detail?.bseCityState?.locName)
        .join("، "); // Join names with Persian comma
      return ` از  ${subscription.description} ${neighborhoods} کمتر از ${remainingDays} روز باقی مانده است`;
    });

    return messages;
  };
  const handleClose = () => {
    setShowRemainingDays(false)
    localStorage.setItem("dismissedDate", new Date().toDateString());
  }
  useEffect(() => {
    const dismissedDate = localStorage.getItem("dismissedDate");
    const today = new Date().toDateString();
    console.log(dismissedDate !== today, "dismissedDate !== today");
    if (dismissedDate !== today) {
      setShowRemainingDays(true);
    }
  }, [subscriptionMains]);
  const messages = getSubscriptionsWithLessThanSevenDays(subscriptionMains);
  const getLocationText = () => {
    if (selectedProvinceID && !selectedCityID) return selectedProvinceName;
    if (selectedCityID) return selectedCityName;
    return "تهران";
  };
  useEffect(() => {
    // getLocationText()


    getLocationName((selectedProvinceID && !selectedCityID) ? selectedProvinceID : selectedCityID)
  }, [selectedCityID, selectedProvinceID])

  return (
    <>
      <div className="sm:hidden md:hidden lg:hidden flex items-center justify-between p-4  border-b fixed  top-0  w-full bg-white z-50 ">
        <div className="flex items-center">
          <Link to={"/"}>
            <img src="/icons/pelake-man-desktop-header-logo.svg" alt="pelakeman" />

          </Link>
          <div className="bg-gray-300 w-[2px] h-[50px] mx-6"></div>
          {/* <div className="bg-[#E3E3E3] text-[#6F6F6F] flex items-center px-6 py-1 max-h-[40px] rounded-xl"   >

            <span className="cursor-pointer"> {localStorage.getItem("pelakToken") ? <span onClick={() => setIsChooseProvinceModalOpen(true)}>
             
              {locationName?.locName}
            </span> : <Link to={"/LoginStepOne"}>ورود</Link>}</span>

            {localStorage.getItem("pelakToken") ? <div className="bg-cover bg-center w-[20px] h-[20px] bg-img-location mr-1"></div> : <img src="icons/login.svg" alt="" />}

          </div> */}

          <div
            className="bg-[#E3E3E3] text-[#6F6F6F] flex items-center px-6 py-1 max-h-[40px] rounded-xl cursor-pointer"
            onClick={() => {
              if (localStorage.getItem("pelakToken")) {
                // setIsChooseProvinceModalOpen(true);
                setIsChooseLocModalOpen(true);
              } else {
                window.location.href = "/LoginStepOne"; // Or use navigate if you're using react-router
              }
            }}
          >
            <span>
              {localStorage.getItem("pelakToken") ? (
                locationName?.locName
              ) : (
                "ورود"
              )}
            </span>

            {localStorage.getItem("pelakToken") ? (
              <div className="bg-cover bg-center w-[20px] h-[20px] bg-img-location mr-1"></div>
            ) : (
              <img src="icons/login.svg" alt="" />
            )}
          </div>

          {showRemainingDays && messages.length > 0 ?
            <div className="flex flex-col">
              <button
                className="text-red-500 text-[25px] font-bold w-5 h-8 cursor-pointer"
                onClick={handleClose}
              >
                ×
              </button>
              <div className="flex flex-col mr-2">


                {messages?.map((message) => (<span className="text-sm text-[13px] text-gray-400">{message} !</span>))}
              </div>
            </div> : <></>}
          <div className="enamad-logo-wrapper">
            {/* <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=485134&Code=3ukamdkJwYq8fkxrUeRB1gPFXGVbl7wT'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=485134&Code=3ukamdkJwYq8fkxrUeRB1gPFXGVbl7wT' alt='' style={{cursor: 'pointer'}} Code='3ukamdkJwYq8fkxrUeRB1gPFXGVbl7wT' /></a> */}
            <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=128203&Code=Ry9qr6JsSFNQeDPRodyE'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=128203&Code=Ry9qr6JsSFNQeDPRodyE' alt='' style={{ cursor: 'pointer' }} code='Ry9qr6JsSFNQeDPRodyE' /></a>
          </div>



        </div>

        {location.pathname === "/" ||
          location.pathname.slice(0, 18) == "/buildingMaterials" ||
          location.pathname.slice(0, 7) == "/metals" ||
          location.pathname.slice(0, 15) == "/services-labor" ||
          location.pathname.slice(0, 9) == "/communal" ||
          location.pathname.slice(0, 14) == "/machine-tools" ||
          location.pathname.slice(0, 21) == "/architect-contractor" ||
          location.pathname.slice(0, 20) == "/CommissionCalculate" ||
          location.pathname === "/CreateFile" ||
          location.pathname === "/CategoryView" ||
          location.pathname === "/" ||
          location.pathname === "/LoginStepOne" ||
          location.pathname === "/LoginLocation" ||
          location.pathname === "/LoginSecondStep" ||
          location.pathname === "/invitaion" ||
          location.pathname === "/property" ||
          location.pathname.slice(0, 16) === "/AdvertiseDetail" ||
          location.pathname.slice(0, 9) === "/ChatPage" ||
          location.pathname.slice(0, 11) === "/FollowPage" ||
          location.pathname === "/Messages" ||
          location.pathname === "/SplashView" ? (
          <div className="grid grid-cols-1 gap-2 ">
            <div className="">
              <div className="w-full  flex items-center rounded-lg  bg-gray-100 xl:justify-between">
                <div className="flex items-center relative xl:w-full max-h-[3px] rounded-sm">

                  <SearchInput onSearch={searchHandler} setSearchValueFromAllAds={setSearchValueFromAllAds} setIsSearch={setIsSearch} />
                </div>

                {/* <div className="flex items-center gap-1 ">
                  {localStorage.getItem("pelakToken") ? (
                    <button className="bg-gray-200 rounded-l-lg hover:text-white shadow-[0px_0px_1px_0px_#00FF3899] group-change-location-icon transition-all flex py-1 gap-1 items-center justify-center px-5 p-2   text-[#6F6F6F] ">
                      <span>
                        {localStorage.getItem("locationNameVeeu")
                          ? JSON.parse(localStorage.getItem("locationNameVeeu"))
                            .locName
                          : "تهران"}
                      </span>
                      <div className="bg-cover bg-center w-[20px] h-[20px] bg-img-location"></div>
                    </button>
                  ) : (
                    <Link
                      to={"/LoginStepOne"}
                      className="shadow-[0px_0px_1px_0px_#00FF3899] flex py-1 gap-1 items-center justify-center px-5 p-2  text-blue-600 rounded rounded-lg"
                    >
                      <p>ورود</p>
                      <img src="icons/login.svg" alt="" />
                    </Link>
                  )}
                </div> */}
              </div>
            </div>
          </div>
        ) : (
          // <div
          //   onClick={() => setIsShowLogOutModal(true)}
          //   className="cursor-pointer flex items-center rounded-md border border-1 bg-white  px-4 py-1 group gap-1"
          // >
          //   <img src="/desktop/icons/logout.svg" alt="" />
          //   <p className="group-hover:font-bold transition-all">
          //     خروج
          //   </p>
          // </div>

          <>
            {() => setTrue()}
          </>
        )}

        <div className="flex items-center   xl:justify-between lg:w-full lg:max-w-full  max-w-[1200px]  ">
          {/* <Link to={"/"}>
            <img src="/icons/pelake-man-desktop-header-logo.svg" alt="pelakeman" />
          </Link>
          <div className="bg-gray-300 w-[2px] h-[50px] mx-6"></div> */}
          {desMenuItems.map((item) =>
            item.id == 4 || item.id == 2 ? (
              <div
                onClick={() => checkAuthForAddOrder(item.id)}
                key={item.id}
                className={`${item.id == 2 && "text-[#D72020] font-bold"
                  } hover:bg-light-gray  hover:rounded-md dark:hover:text-black cursor-pointer flex items-center gap-1 p-2 transition-all 
                                ${activeMenuItem == item.id
                    ? "border-b border-b border-b-2 border-b-gray-600 font-bold "
                    : "border-none"
                  }`}
              >
                <img src={item.src} alt={item.alt} className="" />
                <h2>{item.title}</h2>
              </div>
            ) : (
              <Link
                onClick={() => setActiveMenuItem(item.id)}
                key={item.id}
                to={item.link}
                className={`cursor-pointer flex items-center gap-1 p-2 transition-all hover:text-gray-700 hover:bg-light-gray  hover:rounded-md transition-all
                                ${activeMenuItem == item.id
                    ? "border-b border-b-2 border-b-gray-600 font-bold "
                    : "border-none"
                  }`}
              >
                <img src={item.src} alt={item.alt} />
                <h2>{item.title}</h2>
              </Link>
            )
          )}
          {/* 
          {console.log("nini")
          }
          {console.log("isExitVisible", isExitVisible)
          }
           */}
          {
            isExitVisible &&
            <div className="flex cursor-pointer" onClick={() => setIsShowLogOutModal(true)}>
              <img src="/desktop/icons/logout.svg" alt="" />
              <p>خروج</p>
            </div>
          }

          {/* {
                    desMenuItems.map(item => (
                        <div key={item.id} onClick={() => setActiveMenuItem(item.id)} className={`flex items-center gap-1 p-2 transition-all ${activeMenuItem == item.id ? "border-b" : "border-none"}`}>
                            <img src={item.src} alt="logo" />
                            <h2>{item.title}</h2>
                        </div>
                    ))
                } */}
        </div>
      </div >
      {/* <Modal title="انتخاب آدرس" open={isChooseProvinceModalOpen} onCancel={() => setIsChooseProvinceModalOpen(false)} footer={null} className="!w-[320px]">
        <div className="w-[90%] mx-auto">
          <Dropdown menu={menuProps}>
            <div className="flex justify-between cursor-pointer border-b-[1px] py-2">
              <span>{selectedProvinceName}</span>
              <img src="/icons/arrow-up-simple-2.svg" alt="icon" />
            </div>
          </Dropdown>
          {selectedProvinceID ? (<Dropdown menu={cityMenuProps}>
            <div className="flex justify-between cursor-pointer border-b-[1px] py-2">
              <span>{selectedCityName}</span>
              <img src="/icons/arrow-up-simple-2.svg" alt="icon" />
            </div>
          </Dropdown>) : (<></>)}

        </div>
    
      </Modal> */}
      <ChooseLocModal isChooseLocModalOpen={isChooseLocModalOpen} setIsChooseLocModalOpen={setIsChooseLocModalOpen}/>
      <div
        onClick={(e) => closeModalsWithClickOnDocument(e)}
        className={`right-0 sm:hidden md:hidden style-for-close-on-outside ${isShowLogoutModal ? "top-0" : "top-[100000px] "
          } fixed duration-700 w-full h-screen bg-[#8d8d8da1] transition-all flex justify-center items-center z-50`}
      >
        {/* <div className='flex justify-center items-center rounded-lg bg-white w-[50%] flex-col text-center pb-12 pl-4 pr-4 pt-2 shadow-[0px_-1px_10px_1px_#000000] bg-white'> */}
        <div
          className={`z-50 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 border-5 rounded-xl p-4 bg-red-400 text-white flex flex-col items-center justify-center gap-4 w-80 shadow-sm`}
        >
          <p className="text-xl font-bold">آیا از خروج اطمینان دارید؟</p>
          <div className="flex justify-around items-center w-full">
            <button
              onClick={handleYes}
              className="mx-3 w-1/2 text-white-900 px-6 py-2 rounded-xl bg-red-500 z-50"
            >
              بله
            </button>
            <button
              onClick={() => setIsShowLogOutModal(false)}
              className="mx-3 w-1/2 text-red-800 px-6 py-2 rounded-xl bg-orange-500 z-50 "
            >
              خیر
            </button>
          </div>
        </div>
        {/* </div> */}
      </div>
      {/* <div className={`  ${openSuccess ? "top-0" : "top-[100000px] "} z-50 duration-1000  absolute w-full h-screen`}>
                <div className='rounded-xl p-4 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white flex bg-green-700 flex-col items-center justify-center w-[40%] shadow-sm'>
                    <p className='text-xl font-bold'>با موفقیت خارج شدید</p>
                </div>
            </div> */}
      {/* <div className="hidden">
        <NewFilter isSearch={isSearch} setIsSearch={setIsSearch} setSearchValue={setSearchValueFromAllAds} searchValue={searchValueFromAllAds} onSearchTriggered={newFilterSearchRef} />
      </div> */}
      {
        showLoginAlert ? (
          <LoginAlert
            showLoginAlert={showLoginAlert}
            setShowLoginAlert={setShowLoginAlert}
          />
        ) : (
          ""
        )
      }
    </>
  );
}

export default DesktopHeader;
